let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aOoSy")).then(() => parcelRequire('7jnAA'));